// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"styles_NotFound__3vq3K"};